import { render, staticRenderFns } from "./OrdTable.vue?vue&type=template&id=5d232b42"
import script from "./OrdTable.vue?vue&type=script&lang=ts"
export * from "./OrdTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports